import type { Order, OrderResponse, OrderUpdatePayload, OrdersQueryParams } from './orders-types'
import { api } from '@/api/api'

export const ordersService = {
  get: async (params: OrdersQueryParams) => {
    const { data } = await api.get<OrderResponse>('/orders/', {
      params
    })
    return data
  },
  getByAutoId: async (autoid: string) => {
    const { data } = await api.get<Order>(`/orders/${autoid}/`)
    return data
  },
  update: async (autoid: string, payload: Partial<OrderUpdatePayload>) => {
    const { data } = await api.patch<Order>(`/orders/${autoid}/`, payload)

    return data
  },

  /** Marks order shipped in packaging / eBMS (backend contract). */
  ship: async (autoid: string) => {
    const { data } = await api.post<Order>(`/orders/${autoid}/ship/`)
    return data
  },

  /**
   * Switch packaging unit type for order (may bulk-unassign bundles / delete skids per backend).
   */
  switchPackagingShippingUnitType: async (
    autoid: string,
    payload: { target_type: 'skid' | 'loose_handbomb' }
  ) => {
    const { data } = await api.post<Order>(`/orders/${autoid}/packaging/switch-shipping-unit-type/`, payload)
    return data
  }
}
